
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/songs/[activitySlug]",
      function () {
        return require("private-next-pages/songs/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/songs/[activitySlug]"])
      });
    }
  